__turbopack_context__.v({
  "description-num": "b-a2fq_description-num",
  "element": "b-a2fq_element",
  "graph-content": "b-a2fq_graph-content",
  "info": "b-a2fq_info",
  "root": "b-a2fq_root" + " " + __turbopack_context__.i(975967)["BentoCardSizeCss"],
  "title": "b-a2fq_title",
});
